import { Button, DialogActions, DialogContent } from "@material-ui/core";
import { useSnackbar } from "notistack";
import React, { useRef } from "react";
import { useStoreon } from "storeon/react";
import { DialogContextProps } from "@interfaces/System/DialogContextProps";
import { CreateStaffMemberDto } from "@dto/StaffDto";
import { staffService } from "@services/Staff";
import { TableState } from "@store/table-module";
import CreateStaffMemberForm from "../../Forms/Staff/CreateStaffMemberForm";
import { useLoading } from "@hooks";

const CreateStaffMemberDialogContext = ({ onClose }: DialogContextProps) => {
    const formRef = useRef<any>();

    const { enqueueSnackbar } = useSnackbar();
    const { ref: tableRef } = useStoreon<TableState>("ref");
    const { loadingStatus: submitLoadingStatus, setLoadingStatus: setSubmitLoadingStatus } =
        useLoading("inactivity");

    const invokeSubmit = () => {
        formRef.current.handleSubmit();
    };

    const handleCreateStaffMember = async (values) => {
        setSubmitLoadingStatus("loading");
        try {
            const dto = staffService.plainToClass(CreateStaffMemberDto, values);
            await staffService.createStaffMember(dto);
            enqueueSnackbar("Сотрудник успешно создан", {
                variant: "success",
            });
            onClose();
            await tableRef.current.onQueryChange();
        } catch (err) {
            const message = err.response?.data?.error_tooltip;
            enqueueSnackbar(message || "Произошла ошибка при создании сотрудника", {
                variant: "error",
            });
        }
        setSubmitLoadingStatus("loaded");
    };

    return (
        <>
            <DialogContent>
                <CreateStaffMemberForm onSubmit={handleCreateStaffMember} ref={formRef} />
            </DialogContent>
            <DialogActions>
                <Button color="default" onClick={onClose}>
                    Отмена
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={invokeSubmit}
                    disabled={submitLoadingStatus === "loading"}
                >
                    Сохранить
                </Button>
            </DialogActions>
        </>
    );
};

export default CreateStaffMemberDialogContext;
